// TabNfcLink.js
import React, { useEffect, useMemo }  from 'react';
import { Row, Col, Form, Switch, Input, InputNumber, Select, Tooltip, Typography } from 'antd';
import {
    VerticalAlignTopOutlined, VerticalAlignBottomOutlined, RetweetOutlined, InfoCircleOutlined,
} from '@ant-design/icons';

const { Text } = Typography;

// Helper that wraps any label with an info tooltip.
const labelWithInfo = (label, tooltip) => (
    <span>
    {label}
        <Tooltip title={tooltip}>
      <InfoCircleOutlined style={{ marginLeft: 8, color: '#999' }} />
    </Tooltip>
  </span>
);

const TabNfcLink = ({ showEFN }) => {
    // grab the parent form instance and watch for changes.
    const form = Form.useFormInstance();
    const selectedProgrammePointId = Form.useWatch('SelectedProgrammePointId', form);

    const resolvedPPId = useMemo(() => {
        return selectedProgrammePointId ?? form.getFieldValue('SelectedProgrammePointId');
    }, [selectedProgrammePointId, form]);

    useEffect(() => {
        // Wait until SelectedProgrammePointId is loaded and has changed.
        if (selectedProgrammePointId === undefined) return;

        const current = form.getFieldValue('CreateLeadImmediately');

        // Reset only if undefined or null, never if already true/false
        if (current === undefined || current === null) {
            form.setFieldsValue({ CreateLeadImmediately: false });
        }

    }, [selectedProgrammePointId]);

    return (
        <>
            {/* Tab description */}
            <Row style={{ marginBottom: 16 }}>
                <Col span={24}>
                    <Text type="secondary">
                        Configure the behaviour of scanners on devices assigned to this configuration.
                    </Text>
                </Col>
            </Row>
            <Row gutter={[16, 16]}>
                <Col xs={24} sm={12} md={8}>
                    <Tooltip
                        title={
                            !resolvedPPId
                                ? 'Select a Programme Point in order to activate this option.'
                                : ''
                        }
                        color="#faad14"
                        placement="right"
                    >
                        <Form.Item
                            label={labelWithInfo(
                                'Create Lead Immediately',
                                'Generate a lead as soon as the QR code is scanned',
                            )}
                            name="CreateLeadImmediately_mobile"
                            valuePropName="checked"
                        >
                            <Switch disabled={!resolvedPPId} />
                        </Form.Item>
                    </Tooltip>
                </Col>
                <Col xs={24} sm={12} md={8}>
                    <Form.Item
                        name="AutoCheckInMilliSeconds"
                        label={labelWithInfo(
                            'Delay Milliseconds',
                            'Time delay before automatic check-in (in ms)'
                        )}
                        wrapperCol={{ span: 6 }}
                    >
                        <InputNumber style={{ width: '100%' }} />
                    </Form.Item>
                </Col>
            </Row>
        </>
    );
};

export default TabNfcLink;